import FormField from './FormField'

export default class FormFieldSet {
  constructor (id, title, description, layout, dependencies, fields, type, dependencyDisplay) {
    this.id = id
    this.title = title
    this.description = description
    this.layout = layout
    this.dependencies = dependencies
    this.fields = fields
    this.isDependenciesSatisfied = true
    this.type = type
    this.dependencyDisplay = dependencyDisplay
  }

  static asFormFieldSets (json) {
    return json.map((fieldSet, index) => {
      return FormFieldSet.asFormFieldSet(fieldSet, index)
    })
  }

  static asFormFieldSet (json, fieldSetIndex) {
    return new FormFieldSet(
      json.id,
      json.title,
      json.description,
      json.layout,
      json.dependencies,
      json.form_fields ? FormField.asFormFields(json.form_fields, fieldSetIndex) : [],
      json.type || null,
      json.dependency_display || null
    )
  }

  setIsDependenciesSatisfied (value, formData) {
    this.isDependenciesSatisfied = value
    this.fields.forEach(field => {
      formData.validations[field.id].is_dependencies_satisfied = value
    })
  }

  checkFieldSetDependencies (formData) {
    if (!this.dependencies || this.dependencies.length < 1) {
      this.setIsDependenciesSatisfied(true, formData)
      return
    }
    for (let dependency of this.dependencies) {
      let dgUid = FormField.createFieldId(dependency.dependent_form_field, 0) // use a random number, 0 or anything will work
      for (let key in formData.fields) {
        if (key.replace(/[0-9]/g, '') === dgUid.replace(/[0-9]/g, '')) { // compare UIDs without considering the index
          if (formData.fields[key] && formData.fields[key].getValue() !==
              FormField.parseValue(dependency.required_value, formData.fields[key].type)) {
            this.resetNestedDependants(formData)
            return
          }
        }
      }
    }

    this.setIsDependenciesSatisfied(true, formData)
  }

  getFormFieldSetsForFieldId (fieldUid, formData) {
    let fieldSets = []
    for (let key in formData.dependencies) {
      if (key.includes(fieldUid)) {
        fieldSets = fieldSets.concat(formData.dependencies[key])
      }
    }
    return fieldSets
  }

  // sets all fieldSet's field data values to null
  resetFields (formData) {
    for (let field of this.fields) {
      formData.fields[field.dataFieldId].resetValue()
    }
  }

  // a recursive function that resets all fieldSets that are dependent on
  // this fieldSet or on any nested fieldSet dependent on this one
  resetNestedDependants (formData) {
    this.resetFields(formData)
    this.setIsDependenciesSatisfied(false, formData)
    for (let field of this.fields) {
      let dependantFieldSets = this.getFormFieldSetsForFieldId(field.uid, formData)
      for (let fieldSet of dependantFieldSets) {
        fieldSet.resetNestedDependants(formData)
      }
    }
  }

  sortFields () {
    this.fields.sort(function (a, b) {
      return a.layout.position - b.layout.position
    })
  }

  // TODO: used only temporarily to return the field by its hardcoded uid
  getFieldForUID (uid) {
    return this.fields.find(field => {
      return field.uid === uid
    })
  }
}
